window.addEventListener('pageshow', function () {
  var navEntries = performance.getEntriesByType('navigation');
  if (navEntries.length && navEntries[0].type === 'back_forward') {
    window.location.reload();
  }
});

$(document).on("click", ".new-bundle-prod-btn", function(){
  let $this = $(this);
  $this.addClass("active");
  let formData = {
  'items': [{
    'id': $this.attr("data-id"),
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("click", ".new-reviews-tabs-li", function(){
  let title = $(this).attr("data-title");
  $(this).parent().find(".new-reviews-tabs-li").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".new-reviews-tabs-wrapper").find(`.new-reviews-tabs-content`).removeClass("active")
  $(this).parents(".new-reviews-tabs-wrapper").find(`.new-reviews-tabs-content[data-title="${title}"]`).addClass("active");
})

$(document).on("click", ".new-reviews-videos-play", function(){
  if($(this).parents(".new-reviews-videos-item").hasClass("active")){
    $(this).parents(".new-reviews-videos-item").removeClass("active");
    $(this).parent().find(".custom-reviews-videos").trigger("pause");
  }
  else{
    $(this).parents(".new-reviews-videos-item").addClass("active");
    $(this).parent().find(".custom-reviews-videos").trigger("play");
  }
});

$(".custom-reviews-videos").on("timeupdate", function(){
  $(this).parent().find(".new-reviews-videos-seek").css("width", ((($(this).get(0).currentTime)/($(this).get(0).duration))*100)+"%");
})

$(".new-reviews-videos-full-screen").click(function(){
  if($(this).parents(".new-reviews-videos-slide").hasClass("full-screen")){
    $(this).parents(".new-reviews-videos-swiper").removeClass("custom-transform-none");
    $(this).parents(".new-reviews-videos-slide").removeClass("full-screen");
  }
  else{
    $(this).parents(".new-reviews-videos-swiper").addClass("custom-transform-none");
    $(this).parents(".new-reviews-videos-slide").addClass("full-screen");
  }
})

$(document).on("click", ".new-faq-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
    $(this).parent().addClass("active");
  }
  else{
    $(this).parents(".new-faq-wrapper").find(".new-faq-item").removeClass("active");
    $(this).parents(".new-faq-wrapper").find(".new-faq-title").removeClass("active");
    $(this).parents(".new-faq-wrapper").find(".new-faq-content").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
    $(this).parent().addClass("active");
  }
})

$(document).on("click", ".new-mfaq-title", function(){
  $(this).toggleClass("active");
  $(this).next().slideToggle(300);
})

$(document).on("click", ".new-miwt-btn, .new-mlwt-btn, .new-mcta-btn, .new-faq-link, .new-ing-link, .new-brain-lp-htu-btn, .new-brain-lp-ing-btn-2, .new-brain-lp-iwp-btn, .new-golife-ann-text a, .new-golife-slider-btn, .new-golife-faq-link, .new-golife-htu-btn", function(e){
  e.preventDefault();
  if($(this).attr("href").indexOf("#") != -1){
    let id = $(this).attr("href").split("#")[1];
    if($(`#${id}`).length > 0){
      let top = $(`#${id}`).offset().top - 100;
      $("html, body").animate({ scrollTop: top }, 500);
    }
  }
})

$(function(){
  $(".new-main-product-container").each(function(){
  let comb = '';
  $(this).find(".new-main-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
    if($(this).hasClass("new-main-product--flavor-force--one-time")){
      if($(this).closest("section").find(`.custom-sub-opt[value="one"]`).length > 0){
        $(this).closest("section").find(`.custom-sub-opt[value="one"]`).trigger("click");
      }
      if($(this).closest("section").find(`.custom-sub-opt[value="sub"]`).length > 0){
        $(this).closest("section").find(`.custom-sub-opt[value="sub"] + label`).addClass("force--disabled");
      }
      if($(this).closest("section").find(`.v3-buy[value="v3-sub"]`).length > 0){
        $(this).closest("section").find(`.v3-buy[value="v3-sub"] + label`).addClass("force--disabled");
      }
    }
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $(this).find(`.new-main-product-master-select li[data-title="${comb}"]`);
  if($(this).find(".new-main-product-main-swiper").length > 0 && !$(this).find(".new-main-product-main-swiper").hasClass("new-first-time-dont-change")){
    if(master.attr("data-img") != "none"){
      if($(this).find(".custom-sub-opt").length > 0){
        let val = $(this).find(".custom-sub-opt:checked").val();
        if(val == 'sub'){
          if($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).length > 0){
            let ind = parseInt($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).attr("data-index"));
            $(this).find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
          if($(this).find(".new-main-product-option-value-label-hide-sub").length > 0){
            $(this).find(".new-main-product-option-value-label-hide-sub").hide();
          }
        }
        else{
          if($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
            let ind = parseInt($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
            $(this).find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
          if($(this).find(".new-main-product-option-value-label-hide-sub").length > 0){
            $(this).find(".new-main-product-option-value-label-hide-sub").show();
          }
        }
      }
      else{
        if($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($(this).find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $(this).find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
  }
  if($(this).find(".new-main-product-info-price").length > 0){
    if($(this).find(".custom-sub-opt").length > 0 && master.length > 0){
       if($(this).find(".custom-sub-opt:checked").val() == "sub"){
        $(this).find(".new-main-product-info-price").html(master.attr("data-discount-1"));
       }
       else{
        $(this).find(".new-main-product-info-price").html(master.attr("data-p"));
       }
    }
    else{
      $(this).find(".new-main-product-info-price").html(master.attr("data-p"));
    }
  }

    if($(this).find(".new-main-product-option-value-input").hasClass("new-main-product-different-price")){
      let targetVal = 0;
      let newArr = [];
      $(this).find(".new-main-product-option-value-input:checked").each(function(){
        if(parseInt($(this).val()) != NaN){
          targetVal = parseInt($(this).val());
        }
      })
      $(this).find(".new-main-product-master-select li").each(function(){
        let dt = $(this).attr("data-title").toLowerCase().trim();
        if(targetVal != 0 && dt.indexOf(targetVal) != -1){
          newArr.push($(this).attr("data-title"));
        }
      })
      if(newArr.length > 0){
        for (let i=0; i < newArr.length; i++){
          let td = newArr[i].toLowerCase().trim();
          if(td.indexOf("subscription") != -1){
            let p = $(this).find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
            $(this).find("#custom-sub-option-price").html(p);
            $(this).find(".new-mm-pdp-buy-price-block").html(p);
          }
          else if(td.indexOf("one time") != -1){
            let p = $(this).find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
            $(this).find("#custom-one-option-price").html(p);
            $(this).find(".new-mm-pdp-buy-one-price-block").html(p);
          }
        }
      } 
    }
  })
})

$(document).on("change", ".custom-sub-opt", function(){
  let $this = $(this).parents(".new-main-product-container");
  let comb = '';
  $this.find(".new-main-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $this.find(`.new-main-product-master-select li[data-title="${comb}"]`);
  let __val = $this.find(".custom-sub-opt:checked").val();
  $this.attr("data-active-plan", __val)
  if($this.find(".new-main-product-main-swiper").length > 0){
    if(master.attr("data-img") != "none"){
      if($this.find(".custom-sub-opt").length > 0){
        let val = $this.find(".custom-sub-opt:checked").val();
        if(val == 'sub'){
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
        else{
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
      }
      else{
        if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
  }
  if($this.find(".new-main-product-option-value-input").hasClass("new-main-product-different-price")){
    let targetVal = 0;
    let newArr = [];
    $this.find(".new-main-product-option-value-input:checked").each(function(){
      if(parseInt($(this).val()) != NaN){
        targetVal = parseInt($(this).val());
      }
    })
    $this.find(".new-main-product-master-select li").each(function(){
      let dt = $(this).attr("data-title").toLowerCase().trim();
      if(targetVal != 0 && dt.indexOf(targetVal) != -1){
        newArr.push($(this).attr("data-title"));
      }
    })
    if(newArr.length > 0){
      for (let i=0; i < newArr.length; i++){
        let td = newArr[i].toLowerCase().trim();
        if(td.indexOf("subscription") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
          $this.find("#custom-sub-option-price").html(p);
          $this.find(".new-mm-pdp-buy-price-block").html(p);
        }
        else if(td.indexOf("one time") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
          $this.find("#custom-one-option-price").html(p);
          $this.find(".new-mm-pdp-buy-one-price-block").html(p);
        }
      }
    } 
  }
})

$(document).on("change", ".new-main-product-option-value-input", function(){
  // if($(this).hasClass("new-main-product-force--one-time")){
  //   if($(`.custom-sub-opt[value="one"]`).length > 0){
  //     $(`.custom-sub-opt[value="one"]`).trigger("click");
  //   }
  // }
  if($(this).closest("section").find(`.custom-sub-opt[value="sub"]`).length > 0){
    $(this).closest("section").find(`.custom-sub-opt[value="sub"] + label`).removeClass("force--disabled");
  }
  if($(this).closest("section").find(`.v3-buy[value="v3-sub"]`).length > 0){
    $(this).closest("section").find(`.v3-buy[value="v3-sub"] + label`).removeClass("force--disabled");
  }
  let hasOneTimeClass = false;
  let hasBuyOption = false;
  $(this).closest("section").find(".new-main-product-option-value-input:checked").each(function(){
    if($(this).parents(".new-main-product-option-wrapper").hasClass("new-main-product-buy-option")){
      hasBuyOption = true;
    }
    if($(this).hasClass("new-main-product--flavor-force--one-time")){
      hasOneTimeClass = true;
      if($(this).closest("section").find(`.custom-sub-opt[value="one"]`).length > 0){
        $(this).closest("section").find(`.custom-sub-opt[value="one"]`).trigger("click");
      }
      if($(this).closest("section").find(`.custom-sub-opt[value="sub"]`).length > 0){
        $(this).closest("section").find(`.custom-sub-opt[value="sub"] + label`).addClass("force--disabled");
      }
      if($(this).closest("section").find(`.v3-buy[value="v3-sub"]`).length > 0){
        $(this).closest("section").find(`.v3-buy[value="v3-sub"] + label`).addClass("force--disabled");
      }
    }
  })
  if(!hasBuyOption){
    if(!hasOneTimeClass){
      if($(this).closest("section").find(`.custom-sub-opt[value="sub"]`).length > 0){
        $(this).closest("section").find(`.custom-sub-opt[value="sub"]`).trigger("click");
      }
    }
  }
  let $target = $(this);
  let $this = $(this).parents(".new-main-product-container");
  let comb = '';
  $this.find(".new-main-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $this.find(`.new-main-product-master-select li[data-title="${comb}"]`);
  if($this.find(".new-main-product-main-swiper").length > 0){
    if(master.attr("data-img") != "none"){
      if($this.find(".custom-sub-opt").length > 0){
        let val = $this.find(".custom-sub-opt:checked").val();
        if(val == 'sub'){
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-sub-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
        else{
          if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
            let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
            $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
          }
        }
      }
      else{
        if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
  }
  if($this.find(".new-main-product-info-price").length > 0){
    if($this.find(".custom-sub-opt").length > 0 && master.length > 0){
       if($this.find(".custom-sub-opt:checked").val() == "sub"){
        $this.find(".new-main-product-info-price").html(master.attr("data-discount-1"));
       }
       else{
        $this.find(".new-main-product-info-price").html(master.attr("data-p"));
       }
    }
    else{
      $this.find(".new-main-product-info-price").html(master.attr("data-p"));
    }
  }
  if(master.length){
    if(master.attr("data-sold") == "sold"){
      $this.find(".new-main-product-submit").addClass("sold");
      $this.find(".new-main-product-submit").removeClass("preorder");
      $this.find(".new-main-product-submit span").text("Flavor Out of Stock");
      $this.find(".new-mm-pdp-buy--atc").addClass("sold");
      $this.find(".new-mm-pdp-buy--atc").removeClass("preorder");
      if($this.find(".new-main-product-preorder-text").length > 0){
        $this.find(".new-main-product-preorder-text").removeClass("active");
      }
    }
    else{
      $this.find(".new-main-product-submit").removeClass("sold");
      $this.find(".new-mm-pdp-buy--atc").addClass("sold");
      if(master.attr("data-preorder") == "true"){
        $this.find(".new-main-product-submit").addClass("preorder");
        $this.find(".new-mm-pdp-buy--atc").addClass("preorder");
        $this.find(".new-main-product-submit span").text($this.find(".new-main-product-submit").attr("data-preorder-text"));
        if($this.find(".new-main-product-preorder-text").length > 0){
          $this.find(".new-main-product-preorder-text").addClass("active");
        }
      }
      else{
        $this.find(".new-main-product-submit").removeClass("preorder");
        $this.find(".new-mm-pdp-buy--atc").removeClass("sold");
        $this.find(".new-main-product-submit span").text("Add to Cart");
        if($this.find(".new-main-product-preorder-text").length > 0){
          $this.find(".new-main-product-preorder-text").removeClass("active");
        }
      }
    }
    $this.find(".new-main-product-submit").attr("data-id", master.attr("data-id"));
    $this.find(".new-main-product-submit").attr("data-selling-plan", master.attr("data-selling-plan"));
    $this.find(".new-mm-pdp-buy--atc").attr("data-id", master.attr("data-id"));
    $this.find(".new-mm-pdp-buy-sub-btn").attr("data-selling-plan", master.attr("data-selling-plan"));
    $this.find("#custom-sub-option-price").html(master.attr("data-discount-1"));
    $this.find(".custom-sub-name-inner").html(master.attr("data-selling-plan-name"));
    $this.find(".new-mm-pdp-buy-price-block").html(master.attr("data-discount-1"));
    $this.find("#custom-one-option-price").html(master.attr("data-price"));
    $this.find(".new-mm-pdp-buy-one-price-block").html(master.attr("data-price"));
    $this.find(".new-mm-pdp-buy-one-btn span").html(master.attr("data-price"));

    if($target.hasClass("new-main-product-different-price")){
      let targetVal = 0;
      let newArr = [];
      $this.find(".new-main-product-option-value-input:checked").each(function(){
        if(parseInt($(this).val()) != NaN){
          targetVal = parseInt($(this).val());
        }
      })
      $this.find(".new-main-product-master-select li").each(function(){
        let dt = $(this).attr("data-title").toLowerCase().trim();
        if(targetVal != 0 && dt.indexOf(targetVal) != -1){
          newArr.push($(this).attr("data-title"));
        }
      })
      if(newArr.length > 0){
        for (let i=0; i < newArr.length; i++){
          let td = newArr[i].toLowerCase().trim();
          if(td.indexOf("subscription") != -1){
            let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
            $this.find("#custom-sub-option-price").html(p);
            $this.find(".new-mm-pdp-buy-price-block").html(p);
          }
          else if(td.indexOf("one time") != -1){
            let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
            $this.find("#custom-one-option-price").html(p);
            $this.find(".new-mm-pdp-buy-one-price-block").html(p);
          }
        }
      } 
    }

    if($this.find(".new-main-product-option-quantity-label").length > 0 && $this.find(".new-main-product-option-value-input--swatch").length > 0){
      let swatch = $this.find(".new-main-product-option-value-input--swatch:checked").val();
      let per_serving = [];
      $this.find(".new-main-product-master-select li").each(function(){
        if($(this).attr("data-title").indexOf(swatch) != -1){
          per_serving.push($(this).attr("data-per"));
        }
      })
      $this.find(".new-main-product-option-quantity-label").each(function(index){
        $(this).find(".new-main-product-option-quantity-per").html(per_serving[index]);
      })
    }
  }
  else{
    $this.find(".new-main-product-submit").addClass("sold");
    $this.find(".new-mm-pdp-buy--atc").addClass("sold");
    $this.find(".new-main-product-submit span").text("Flavor Out of Stock");
  }
  if($this.find(".custom-sub-opt").length > 0){
    $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dt").removeClass("active");
    $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dd").show();
  }
  if($this.find(".new-main-product-option-value-input--swatch:checked + .new-main-product-option-value-label--swatch").hasClass("new-main-product-option-value-label-hide-sub")){
    let hide_val = $this.find(".new-main-product-option-value-input--swatch:checked").val();
    if(hide_val.indexOf("(") != -1){
      let hide_discount = parseInt(hide_val.split("(")[1]);
      if($this.find(".custom-sub-opt").length > 0){
        $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dt dl").text(` ${hide_discount}% off`);
        $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dd").hide();
        $this.find(".custom-sub-opt[value='one'] + label .custom-sub-name-wrapper dt").addClass("active");
        if($("#custom-one-option-price").length > 0){
          let hp = parseFloat($(master).attr("data-hide-p"));
          let disc = hp  - (hp * hide_discount / 100);
          $this.find("#custom-one-option-price").html(`<span>${Shopify.formatMoney(disc)}</span><strike>${Shopify.formatMoney(hp)}</strike>`);
          $this.find(".new-mm-pdp-buy-one-price-block").html(`<span>${Shopify.formatMoney(disc)}</span><strike>${Shopify.formatMoney(hp)}</strike>`);
        }
      }
    }
  }

  if($(this).parents(".new-main-product-info-block").hasClass("new-main-product-info-variants--block")){
    if(master.length){
      let fblock = $(this).parents(".new-main-product-info-variants--block");
      let type = fblock.attr("data-type");
      let pid = fblock.attr("data-pid");
      let furl = $(this).parents(".new-main-product-info-variants--block").attr("data-url") + master.attr("data-id");
      let $parent = $(this).parents(".new-main-product-info-variants--block");
      fblock.addClass("az-active");
      $.ajax({
        url: furl,
        dataType: "html",
        success: function(result){
          if(type == 'page'){
            $parent.html($(result).find(`.new-main-product-info-variants--block[data-pid="${pid}"]`).html());
          }
          else{
            $parent.html($(result).find(".new-main-product-info-variants--block").html());
          }
        },
      })
      .always(function(){
        fblock.removeClass("az-active");
      })
    }
  }
})

$(document).on("click", ".new-main-product-submit", function(){
  let $parent = $(this).parents(".new-main-product-container");
  let $this = $(this);
  let $variantUpsell = $parent.find(`.new-main-product-master-select li[data-id="${$this.attr("data-id")}"]`).attr("data-upsell");
  let $variantUpsellOne = $parent.find(`.new-main-product-master-select li[data-id="${$this.attr("data-id")}"]`).attr("data-upsell-one");
  let arr = [];
  $this.addClass("active");
    if($(".custom-sub-opt").length > 0){
      let val = $parent.find(".custom-sub-opt:checked").val();
      if(val == 'sub'){
        if($variantUpsell != "none" && $variantUpsell != undefined){
          let variantUpsells = $variantUpsell.split(",");
          for(item of variantUpsells){
            arr.push({
              'id': item.trim(),
              'quantity': 1
            })
          }
        }
        else{
          if($this.parents(".new-main-product-container").find(".new-mp-upsell").length > 0){
            $this.parents(".new-main-product-container").find(".new-mp-upsell").each(function(){
              if($(this).attr("data-sp") != undefined && $(this).attr("data-sp") != "none"){
                arr.push({
                  'id': $(this).val(),
                  'quantity': 1,
                  'selling_plan': $(this).attr("data-sp")
                })
              }
              else{
                arr.push({
                  'id': $(this).val(),
                  'quantity': 1
                })
              }
            })
          }
        }
        if($this.hasClass("preorder")){
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1,
            'selling_plan': $this.attr("data-selling-plan"),
            'properties': {'Preorder':'true'}
          })
        }
        else{
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1,
            'selling_plan': $this.attr("data-selling-plan")
          })
        }
      }
      else{
        if($variantUpsellOne != "none" && $variantUpsellOne != undefined){
          let variantUpsellOne = $variantUpsellOne.split(",");
          for(item of variantUpsellOne){
            arr.push({
              'id': item.trim(),
              'quantity': 1
            })
          }
        }
        else{
          if($this.parents(".new-main-product-container").find(".new-mp-upsell-one").length > 0){
            $this.parents(".new-main-product-container").find(".new-mp-upsell-one").each(function(){
              arr.push({
                'id': $(this).val(),
                'quantity': 1
              })
            })
          }
        }
        if($this.hasClass("preorder")){
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1,
            'properties': {'Preorder':'true'}
          })
        }
        else{
          arr.push({
            'id': $this.attr("data-id"),
            'quantity': 1
          })
        }
      }
    }
    else{
      if($variantUpsellOne != "none" && $variantUpsellOne != undefined){
        let variantUpsellOne = $variantUpsellOne.split(",");
        for(item of variantUpsellOne){
          arr.push({
            'id': item.trim(),
            'quantity': 1
          })
        }
      }
      else{
        if($this.parents(".new-main-product-container").find(".new-mp-upsell-one").length > 0){
          $this.parents(".new-main-product-container").find(".new-mp-upsell-one").each(function(){
            arr.push({
              'id': $(this).val(),
              'quantity': 1
            })
          })
        }
      }
      if($this.hasClass("preorder")){
        arr.push({
          'id': $this.attr("data-id"),
          'quantity': 1,
          'properties': {'Preorder':'true'}
        })
      }
      else{
        arr.push({
          'id': $this.attr("data-id"),
          'quantity': 1
        })
      }
    }
    let formData = {
      'items': arr
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(function(res){
      if(res.status){
        console.log("error");
        if($this.hasClass("preorder")){
          if($parent.find(".new-main-product-preorder-limit-text").length > 0){
            $parent.find(".new-main-product-preorder-limit-text").addClass("active");
            setTimeout(function(){
              $(".new-main-product-preorder-limit-text").removeClass("active");
            }, 3000)
          }
          else{
            $parent.find(".new-main-product-error").text(res.message);
            $parent.find(".new-main-product-error").addClass("active");
            setTimeout(function(){
              $parent.find(".new-main-product-error").removeClass("active");
            }, 3000)
          }
        }
        else{
          $parent.find(".new-main-product-error").text(res.message);
          $parent.find(".new-main-product-error").addClass("active");
          setTimeout(function(){
            $parent.find(".new-main-product-error").removeClass("active");
          }, 3000)
        }
      }
      else{
        if($(this).hasClass("direct--checkout")){
          window.location.href = '/checkout';
        }
        else{
          $(".cart-icon-wrap .open-drawer").trigger("click");
        }
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(function(){
      $this.removeClass("active");
    });
})

$(document).on("change", ".custom-sub-opt", function(){
  let $this = $(this).parents(".new-main-product-container");
  let buy_wrapper = $this.find(".new-main-product-buy-option");
  if(buy_wrapper != undefined && buy_wrapper.length > 0){
    if($(this).val() == 'sub'){
      buy_wrapper.find(`.new-main-product-option-value-input[data-val="subscription"]`).trigger("click");
    }
    else{
      buy_wrapper.find(`.new-main-product-option-value-input[data-val="one-time"]`).trigger("click");
    }
  }
  if($(this).val() == 'sub'){
    if($this.find(".new-main-product-option-value-label-hide-sub").length > 0){
      $this.find(".new-main-product-option-value-label-hide-sub").hide();
      if($this.find(".new-main-product-option-value-input--swatch:checked + .new-main-product-option-value-label--swatch").hasClass("new-main-product-option-value-label-hide-sub")){
        $this.find(".new-main-product-option-value-input--swatch").eq(0).trigger("click");
      }
    }
  }
  else{
    if($this.find(".new-main-product-option-value-label-hide-sub").length > 0){
      $this.find(".new-main-product-option-value-label-hide-sub").show();
    }
  }

  if($this.find(".new-main-product-option-value-input").hasClass("new-main-product-different-price")){
    let targetVal = 0;
    let newArr = [];
    $this.find(".new-main-product-option-value-input:checked").each(function(){
      if(parseInt($(this).val()) != NaN){
        targetVal = parseInt($(this).val());
      }
    })
    $this.find(".new-main-product-master-select li").each(function(){
      let dt = $(this).attr("data-title").toLowerCase().trim();
      if(targetVal != 0 && dt.indexOf(targetVal) != -1){
        newArr.push($(this).attr("data-title"));
      }
    })
    if(newArr.length > 0){
      for (let i=0; i < newArr.length; i++){
        let td = newArr[i].toLowerCase().trim();
        if(td.indexOf("subscription") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-discount-1");
          $this.find("#custom-sub-option-price").html(p);
          $this.find(".new-mm-pdp-buy-price-block").html(p);
        }
        else if(td.indexOf("one time") != -1){
          let p = $this.find(`.new-main-product-master-select li[data-title="${newArr[i]}"]`).attr("data-price");
          $this.find("#custom-one-option-price").html(p);
          $this.find(".new-mm-pdp-buy-one-price-block").html(p);
        }
      }
    } 
  }

  if($this.find(".new-mm-pdp-buy").length > 0){
    if($(this).val() == 'sub'){
      $this.find(`.v3-buy[value="v3-sub"]`).prop("checked", true);
    }
    else{
      $this.find(`.v3-buy[value="v3-one"]`).prop("checked", true);
    }
  }
})


  class TypingText extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.container = document.createElement('span');
      this.shadowRoot.appendChild(this.container);
    }

    connectedCallback() {
      const sentencesAttr = this.getAttribute('sentences');
      if (!sentencesAttr) return;

      this.sentences = sentencesAttr.split(',').map(s => s.trim());
      this.speed = parseInt(this.getAttribute('speed')) || 60;
      this.loop = this.hasAttribute('loop');

      this.startTyping();
    }

    async startTyping() {
      let index = 0;

      do {
        const sentence = this.sentences[index];
        await this.typeSentence(sentence);
        await this.wait(1000);
        await this.deleteSentence(sentence);
        await this.wait(500);
        
        index = (index + 1) % this.sentences.length;
      } while (this.loop || index !== 0);
    }

    async typeSentence(sentence) {
      for (let i = 0; i < sentence.length; i++) {
        this.container.textContent += sentence[i];
        await this.wait(this.speed);
      }
    }

    async deleteSentence(sentence) {
      for (let i = sentence.length; i > 0; i--) {
        this.container.textContent = this.container.textContent.slice(0, -1);
        await this.wait(this.speed);
      }
    }

    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
  }

  customElements.define('typing-text', TypingText);

  $(document).on("click", ".new-main-product-popup-btn, .new-main-product-popup, .new-main-product-popup-close, .new-brain-lp-ing-btn-1, .new-golife-reason-btn", function(){
    if($(this).parents(".shopify-section").find(".new-main-product-popup").length > 0){
      $(this).parents(".shopify-section").find(".new-main-product-popup").toggleClass("active");
      $("html, body").toggleClass("overflow--hidden");
    }
    else{
      $(".new-main-product-popup").toggleClass("active");
      $("html, body").toggleClass("overflow--hidden");
    }
  })
  $(document).on("click", ".new-main-product-popup-container", function(e){
    e.stopPropagation();
  })

  $(document).on("click", ".new-dynamic-header, .new-bfcm-cart", function(){
    $(".cart-icon-wrap .open-drawer").trigger("click");
  })

  $(document).on("click", ".new-research-story-quote-img, .new-research-doctor-iframe-img", function(){
    $(this).hide();
    $(this).parent().find("iframe").show();
    $(this).parent().find("iframe").attr("src", $(this).attr("data-link"));
  })

  $(document).on("click", ".new-research-faq-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  }
  else{
    $(this).parents(".new-research-faq-wrapper").find(".new-research-faq-title").removeClass("active");
    $(this).parents(".new-research-faq-wrapper").find(".new-research-faq-content").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
  }
})


class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.durationHours = parseFloat(this.getAttribute('duration-hours')) || 24;
    this.cookieName = 'countdown_start_time';
  }

  connectedCallback() {
    this.innerHTML = `<span id="timer">--:--:--</span>`;
    this.timerElement = this.querySelector('#timer');
    this.start();
  }

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  start() {
    const durationMs = this.durationHours * 60 * 60 * 1000;
    const now = new Date();
    let startTime = this.getCookie(this.cookieName);

    if (!startTime) {
      startTime = now.getTime();
      this.setCookie(this.cookieName, startTime, 7);
    } else {
      startTime = parseInt(startTime, 10);
    }

    const update = () => {
      const current = Date.now();
      let elapsed = current - startTime;

      if (elapsed >= durationMs) {
        // Restart automatically
        startTime = Date.now();
        this.setCookie(this.cookieName, startTime, 7);
        elapsed = 0;
      }

      const remaining = durationMs - elapsed;
      const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((remaining / (1000 * 60)) % 60);
      const seconds = Math.floor((remaining / 1000) % 60);

      this.timerElement.textContent = 
        `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

      requestAnimationFrame(update);
    };

    update();
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}

$(document).on("click", ".new-brain-lp-mp-button, .new-brain-lp-mp-one-button", function(){
  let $this = $(this);
  let arr = [];
  let $variantUpsell = $this.attr("data-upsell");
  let $variantUpsellOne = $this.attr("data-upsell-one");
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != undefined && $(this).attr("data-selling-plan") != null){
    if($variantUpsell != "none" && $variantUpsell != undefined){
      let variantUpsells = $variantUpsell.split(",");
      for(item of variantUpsells){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.parents(".new-brain-lp-mp-wrapper").find(".new-brain-lp-upsell").length > 0){
        $this.parents(".new-brain-lp-mp-wrapper").find(".new-brain-lp-upsell").each(function(){
          arr.push({
            'id': $(this).val(),
            'quantity': 1
          })
        })
      }
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($variantUpsellOne != "none" && $variantUpsellOne != undefined){
      let variantUpsellOne = $variantUpsellOne.split(",");
      for(item of variantUpsellOne){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.parents(".new-brain-lp-mp-wrapper").find(".new-brain-lp-upsell-one").length > 0){
        $this.parents(".new-brain-lp-mp-wrapper").find(".new-brain-lp-upsell-one").each(function(){
          arr.push({
            'id': $(this).val(),
            'quantity': 1
          })
        })
      }
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      location.href = '/checkout';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("change", ".new-dynamic-product-select", function(){
  let vid = $(this).val();
  let ind = '';
  if($(this).parent().find(".new-dynamic-product-swiper").find(`.new-dynamic-product-img[data-id="${vid}"]`).length > 0){
    ind = $(this).parent().find(".new-dynamic-product-swiper").find(`.new-dynamic-product-img[data-id="${vid}"]`).attr("data-index");
  }
  else{
    let img = $(this).find("option:selected").attr("data-img");
    if(img != "none" && img != undefined){
      if($(this).parent().find(".new-dynamic-product-swiper").find(`.new-dynamic-product-img[src="${img}"]`).length > 0){
        ind = $(this).parent().find(".new-dynamic-product-swiper").find(`.new-dynamic-product-img[src="${img}"]`).attr("data-index");
      }
    }
  }
  let preorder = $(this).find("option:selected").attr("data-preorder");
  let upsell = $(this).find("option:selected").attr("data-upsell");
  $(this).parent().find(".new-dynamic-product-swiper")[0].swiper.slideTo(ind);
  $(this).parent().find(".new-dynamic-product-btn").attr("data-id", vid);
  $(this).parent().find(".new-dynamic-product-btn").attr("data-preorder", preorder);
  $(this).parent().find(".new-dynamic-product-btn").attr("data-upsell", upsell);
  $(this).parent().find(".new-dynamic-product-price-wrapper").html($(this).find("option:selected").attr("data-price"));
  if($(this).parent().find(".new-dynamic-product-btn").attr("data-selling-plan") != undefined && $(this).parent().find(".new-dynamic-product-btn").attr("data-selling-plan") != null){
    let sid = $(this).find("option:selected").attr("data-selling-plan");
    $(this).parent().find(".new-dynamic-product-btn").attr("data-selling-plan", sid);
  }
  if($(this).find("option:selected").attr("data-sold") == "available"){
    $(this).parent().find(".new-dynamic-product-btn").removeClass("sold");
    if(preorder == "true"){
      $(this).parent().find(".new-dynamic-product-btn").find("span").text($(this).parent().find(".new-dynamic-product-btn").attr("data-preorder-text"));
    }
    else{
      $(this).parent().find(".new-dynamic-product-btn").find("span").text("Add To Cart");
    }
  }
  else{
    $(this).parent().find(".new-dynamic-product-btn").addClass("sold");
    $(this).parent().find(".new-dynamic-product-btn").find("span").text("Flavor Out of Stock");
  }
})

$(document).on("click", ".new-dynamic-product-btn", function(){
  let $this = $(this);
  let $variantUpsell = $this.attr("data-upsell");
  let arr = [];
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != undefined && $(this).attr("data-selling-plan") != null){
    if($variantUpsell != "none" && $variantUpsell != undefined){
      let variantUpsells = $variantUpsell.split(",");
      for(item of variantUpsells){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.parents(".new-dynamic-product-container").find(".new-dynamic-product-upsell").length > 0){
        $this.parents(".new-dynamic-product-container").find(".new-dynamic-product-upsell").each(function(){
          arr.push({
            'id': $(this).val(),
            'quantity': 1
          })
        })
      }
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': parseInt($this.attr("data-qty")) || 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': parseInt($this.attr("data-qty")) || 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($variantUpsell != "none" && $variantUpsell != undefined){
      let variantUpsells = $variantUpsell.split(",");
      for(item of variantUpsells){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.parents(".new-dynamic-product-container").find(".new-dynamic-product-upsell-one").length > 0){
        $this.parents(".new-dynamic-product-container").find(".new-dynamic-product-upsell-one").each(function(){
          arr.push({
            'id': $(this).val(),
            'quantity': 1
          })
        })
      }
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': parseInt($this.attr("data-qty")) || 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': parseInt($this.attr("data-qty")) || 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("click", ".new-golife-faq-title", function(){
  $(this).toggleClass("active");
  $(this).next().slideToggle(300);
})

$(document).on("click", ".new-desc-product-info-acc-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  }
  else{
    $(this).parents(".new-desc-product-info-acc-block").find(".new-desc-product-info-acc-title").removeClass("active");
    $(this).parents(".new-desc-product-info-acc-block").find(".new-desc-product-info-acc-content").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
  }
})

$(document).on("change", ".new-desc-product-option-value-input", function(){
  let comb = '';
  $(this).parents(".new-desc-product-info-wrapper").find(".new-desc-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $(`.new-desc-product-master-select li[data-title="${comb}"]`);
  if(master.length > 0){
    if($(".new-desc-product-main-swiper").length > 0){
      if(master.attr("data-img") != "none"){
        if($(`.new-desc-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
          let ind = parseInt($(`.new-desc-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
          $(".new-desc-product-main-swiper")[0].swiper.slideTo(ind);
        }
      }
    }
    if($(".new-desc-product-submit").length > 0){
      $(".new-desc-product-submit").attr("data-id", master.attr("data-id"));
      $(".new-desc-product-submit").attr("data-preorder", master.attr("data-preorder"));
      if(master.attr("data-sold") == "available"){
        $(".new-desc-product-submit").removeClass("sold");
      }
      else{
        $(".new-desc-product-submit").addClass("sold");
      }
    }
    if($(".new-desc-product-selling-plan-input").length > 0){
      let val = $(".new-desc-product-selling-plan-input:checked").val();
      if(val == 'sub'){
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-discount"));
          $(".new-desc-product-info-price em").text(master.attr("data-discount-save"));
          if($(".new-desc-product-submit").length > 0){
            $(".new-desc-product-submit em").text(master.attr("data-atc-discount-price"));
          }
        }
      }
      else{
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-price"));
          $(".new-desc-product-info-price em").text(master.attr("data-price-save"));
          if($(".new-desc-product-submit").length > 0){
            $(".new-desc-product-submit em").text(master.attr("data-atc-price"));
          }
        }
      }
    }
  }
});

$(document).on("change", ".new-desc-product-selling-plan-input", function(){
  let comb = '';
  $(this).parents(".new-desc-product-info-wrapper").find(".new-desc-product-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $(`.new-desc-product-master-select li[data-title="${comb}"]`);
  console.log(master, $(this).val());
  if($(this).val() == 'sub'){
    let val = $(".new-desc-product-selling-plan-select").val();
    $(".new-desc-product-selling-plan-select-wrapper").show();
    if($(".new-desc-product-submit").length > 0){
      $(".new-desc-product-submit").attr("data-selling-plan", val);
      if(master.length > 0){
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-discount"));
          $(".new-desc-product-info-price em").text(master.attr("data-discount-save"));
        }
        $(".new-desc-product-submit em").text(master.attr("data-atc-discount-price"));
      }
    }
  }
  else{
    $(".new-desc-product-selling-plan-select-wrapper").hide();
    if($(".new-desc-product-submit").length > 0){
      $(".new-desc-product-submit").attr("data-selling-plan", "none");
      if(master.length > 0){
        if($(".new-desc-product-info-price-inner-block").length > 0){
          $(".new-desc-product-info-price-inner-block").html(master.attr("data-price"));
          $(".new-desc-product-info-price em").text(master.attr("data-price-save"));
        }
        $(".new-desc-product-submit em").text(master.attr("data-atc-price"));
      }
    }
  }
})

$(document).on("change", ".new-desc-product-selling-plan-select", function(){
  if($(".new-desc-product-submit").length > 0){
    $(".new-desc-product-submit").attr("data-selling-plan", $(this).val());
  }
})

$(document).on("click", ".new-desc-product-submit", function(){
  let $this = $(this);
  let arr = [];
  let $variantUpsell = $this.parents(".new-desc-product-wrapper").find(`.new-desc-product-master-select li[data-id="${$this.attr("data-id")}"]`).attr("data-upsell");
  let $variantUpsellOne = $this.parents(".new-desc-product-wrapper").find(`.new-desc-product-master-select li[data-id="${$this.attr("data-id")}"]`).attr("data-upsell-one");
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != "none"){
    if($variantUpsell != "none" && $variantUpsell != undefined){
      let variantUpsells = $variantUpsell.split(",");
      for(item of variantUpsells){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.parents(".new-desc-product-wrapper").find(".new-desc-upsell").length > 0){
        $this.parents(".new-desc-product-wrapper").find(".new-desc-upsell").each(function(){
          arr.push({
            'id': $(this).val(),
            'quantity': 1
          })
        })
      }
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($variantUpsellOne != "none" && $variantUpsellOne != undefined){
      let variantUpsellOne = $variantUpsellOne.split(",");
      for(item of variantUpsellOne){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.parents(".new-desc-product-wrapper").find(".new-desc-upsell-one").length > 0){
        $this.parents(".new-desc-product-wrapper").find(".new-desc-upsell-one").each(function(){
          arr.push({
            'id': $(this).val(),
            'quantity': 1
          })
        })
      }
    }
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("click", ".new-vault-coll-item-submit, .new-fc-atc", function(){
  let $this = $(this);
  let arr = [];
  $this.addClass("active");
  if($(this).attr("data-selling-plan") != "none"){
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan")
      })
    }
  }
  else{
    if($this.attr("data-preorder") == "true"){
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1,
        'properties': {'Preorder':'true'}
      })
    }
    else{
      arr.push({
        'id': $this.attr("data-id"),
        'quantity': 1
      })
    }
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("change", ".new-fc-select", function(){
  let id = $(this).val();
  let sp = $(this).find("option:selected").attr("data-selling-plan");
  let po = $(this).find("option:selected").attr("data-preorder");
  let sold = $(this).find("option:selected").attr("data-sold");
  let img = $(this).find("option:selected").attr("data-img");
  let price = $(this).find("option:selected").attr("data-price");
  let btn = $(this).parent().find(".new-fc-atc");
  btn.attr("data-selling-plan", sp);
  btn.attr("data-preorder", po);
  btn.attr("data-id", id);
  $(this).closest(".item-single").find("img").attr("src", img);
  $(this).closest(".item-single").find(".new-fp-price").html(price);
  if(sold == "true"){
    btn.addClass("sold");
  }
  else{
    btn.removeClass("sold");
  }
})



  $(function () {
  if (window.BFCountdownDefined) return;
  window.BFCountdownDefined = true;

  class BFCountdown extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.wrapper = document.getElementById(`bf-wrapper-${this.sectionId}`);

      // Example: "Nov/29/2025 06:00 PM"
      this.endDateString = this.dataset.endDate;

      this.daysEl = this.querySelector('[data-unit="days"]');
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');

      this.endTimeUTC = this.parseESTtoUTC(this.endDateString);

      this.start();
    }

    // Convert EST string into UTC date
    parseESTtoUTC(dateString) {
      // dateString example: "Nov/27/2025 02:55 PM"
      
      const parts = dateString.match(/(\w+)\/(\d+)\/(\d+)\s+(\d+):(\d+)\s+(AM|PM)/i);
      if (!parts) return null;

      const months = {
        Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5,
        Jul:6, Aug:7, Sep:8, Oct:9, Nov:10, Dec:11
      };

      const month = months[parts[1]];
      const day   = parseInt(parts[2]);
      const year  = parseInt(parts[3]);
      let hour    = parseInt(parts[4]);
      const minute= parseInt(parts[5]);
      const ampm  = parts[6].toUpperCase();

      if (ampm === "PM" && hour !== 12) hour += 12;
      if (ampm === "AM" && hour === 12) hour = 0;

      // Build EST time manually (UTC -5)
      const est = new Date(Date.UTC(year, month, day, hour + 5, minute, 0));

      return est; // this is now correct UTC timestamp
    }

    start() {
      this.update();
      this.timer = setInterval(() => this.update(), 1000);
    }

    update() {
      const nowUTC = new Date(); // Always compare in UTC

      if (nowUTC >= this.endTimeUTC) {
        this.hideSection();
        return;
      }

      const diff = this.endTimeUTC - nowUTC;
      const totalSeconds = Math.floor(diff / 1000);

      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.render(days, hours, minutes, seconds);
    }

    hideSection() {
      clearInterval(this.timer);
      if (this.wrapper) this.wrapper.style.display = "none";
    }

    render(d, h, m, s) {
      this.daysEl.textContent = this.pad(d);
      this.hoursEl.textContent = this.pad(h);
      this.minutesEl.textContent = this.pad(m);
      this.secondsEl.textContent = this.pad(s);
    }

    pad(n) {
      return n < 10 ? "0" + n : n;
    }
  }

  customElements.define("bf-countdown", BFCountdown);
  });


class TimedVisibility extends HTMLElement {
  connectedCallback() {
    const startStr = this.dataset.start;
    const endStr = this.dataset.end;

    if (!startStr || !endStr) {
      console.warn("TimedVisibility: Missing start or end date.");
      return;
    }

    const startDateUTC = this.parseESTtoUTC(startStr);
    const endDateUTC   = this.parseESTtoUTC(endStr);

    if (!startDateUTC || !endDateUTC) {
      console.error("TimedVisibility: Invalid date format.");
      return;
    }

    const nowUTC = new Date();

    // Compare in UTC (clean & accurate)
    // this.innerHTML = `${nowUTC} >= ${startDateUTC} && ${nowUTC} <= ${endDateUTC}`;
    if (nowUTC >= startDateUTC && nowUTC <= endDateUTC) {
      this.style.display = "flex";
    } else {
      this.style.display = "none";
    }
  }

  // Parse "Nov/27/2025 06:00 PM" into a proper UTC date
  parseESTtoUTC(dateString) {
    const parts = dateString.match(/(\w+)\/(\d+)\/(\d+)\s+(\d+):(\d+)\s+(AM|PM)/i);
    if (!parts) return null;

    const months = {
      Jan:0, Feb:1, Mar:2, Apr:3, May:4, Jun:5,
      Jul:6, Aug:7, Sep:8, Oct:9, Nov:10, Dec:11
    };

    const month  = months[parts[1]];
    const day    = parseInt(parts[2]);
    const year   = parseInt(parts[3]);
    let hour     = parseInt(parts[4]);
    const minute = parseInt(parts[5]);
    const ampm   = parts[6].toUpperCase();

    // Convert AM/PM to 24h format
    if (ampm === "PM" && hour !== 12) hour += 12;
    if (ampm === "AM" && hour === 12) hour = 0;

    // EST is UTC-5 → to convert EST → UTC, we ADD 5 hours
    const utcDate = new Date(Date.UTC(year, month, day, hour + 5, minute, 0));

    return utcDate;
  }
}

customElements.define("timed-visibility", TimedVisibility);


$(document).on("change", ".new-mm-pdp-option-value-input", function(){
  let $this = $(this).parents(".new-mm-pdp");
  let comb = '';
  $this.find(".new-mm-pdp-option-value-input:checked").each(function(){
    comb += $(this).val() + ' / ';
  })
  comb = comb.substring(0, comb.length - 2).trim();
  let master = $this.find(`.new-mm-pdp-master-select li[data-title="${comb}"]`);
  if($this.find(".new-main-product-main-swiper").length > 0){
    if(master.attr("data-img") != "none"){
      if($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).length > 0){
        let ind = parseInt($this.find(`.new-main-product-main-img[data-img="${master.attr("data-img")}"]`).attr("data-index"));
        $this.find(".new-main-product-main-swiper")[0].swiper.slideTo(ind);
      }
    }
  }
  if($this.find(".new-mm-pdp-info-price").length > 0){
    $this.find(".new-mm-pdp-info-price").html(master.attr("data-save-top"));
  }
  if($this.find(".new-mm-pdp-buy-price-block").length > 0){
    $this.find(".new-mm-pdp-buy-price-block").html(master.attr("data-save"));
  }
  if($this.find(".new-mm-pdp-buy-one-title span").length > 0){
    $this.find(".new-mm-pdp-buy-one-title span").text(master.attr("data-single-price"));
    $this.find(".new-mm-pdp-buy-one-btn span").text(master.attr("data-single-price"));
  }
  if(master.length){
    if(master.attr("data-sold") == "sold"){
      $this.find(".new-mm-pdp-buy--atc").addClass("sold");
    }
    else{
      $this.find(".new-mm-pdp-buy--atc").removeClass("sold");
    }
    $this.find(".new-mm-pdp-buy--atc").attr("data-id", master.attr("data-id"));
    $this.find(".new-mm-pdp-buy-sub-btn").attr("data-selling-plan", master.attr("data-selling-plan"));
  }
  else{
    $this.find(".new-mm-pdp-buy--atc").addClass("sold");
    $this.find(".new-mm-pdp-buy--atc").addClass("sold");
  }

  if($(this).parents(".new-mm-pdp-option-block").hasClass("new-main-product-info-variants--block")){
    if(master.length){
      let fblock = $(this).parents(".new-main-product-info-variants--block");
      let url = $(this).parents(".new-main-product-info-variants--block").attr("data-url");
      let furl = $(this).parents(".new-main-product-info-variants--block").attr("data-url") + master.attr("data-id");
      fblock.addClass("az-active");
      $.ajax({
        url: furl,
        dataType: "html",
        success: function(result){
          $(`.new-main-product-info-variants--block[data-url="${url}"]`).html($(result).find(`.new-main-product-info-variants--block[data-url="${url}"]`).html());
        },
      })
      .always(function(){
        fblock.removeClass("az-active");
      })
    }
  }
})

$(document).on("click", ".new-mm-pdp-buy--atc", function(){
  let $this = $(this).parents("section");
  let $th = $(this);
  let $variantUpsell = $this.find(`.new-mm-pdp-master-select li[data-id="${$th.attr("data-id")}"]`).attr("data-upsell");
  let $variantUpsellOne = $this.find(`.new-mm-pdp-master-select li[data-id="${$th.attr("data-id")}"]`).attr("data-upsell-one");
  let arr = [];
  let inMain = $(this).hasClass("new-mm-pdp-buy--atc-main");
  $th.addClass("active");
  if($th.attr("data-selling-plan") != "none"){
    if($variantUpsell != "none" && $variantUpsell != undefined){
      let variantUpsells = $variantUpsell.split(",");
      for(item of variantUpsells){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.find(".new-mm-pdp-buy-upsell-prod").length > 0){
        $this.find(".new-mm-pdp-buy-upsell-prod").each(function(){
          arr.push({
            'id': $(this).attr("data-id"),
            'quantity': 1
          })
        })
      }
    }
    arr.push({
      'id': $th.attr("data-id"),
      'quantity': 1,
      'selling_plan': $th.attr("data-selling-plan")
    })
  }
  else{
    if($variantUpsellOne != "none" && $variantUpsellOne != undefined){
      let variantUpsellOne = $variantUpsellOne.split(",");
      for(item of variantUpsellOne){
        arr.push({
          'id': item.trim(),
          'quantity': 1
        })
      }
    }
    else{
      if($this.find(".new-mm-pdp-buy-upsell-prod-one").length > 0){
        $this.find(".new-mm-pdp-buy-upsell-prod-one").each(function(){
          arr.push({
            'id': $(this).val(),
            'quantity': 1
          })
        })
      }
    }
    arr.push({
      'id': $th.attr("data-id"),
      'quantity': 1
    })
  }
  let formData = {
    'items': arr
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
     if(inMain){
        $(".cart-icon-wrap .open-drawer").trigger("click");
      }
      else{
        location.href = '/checkout';
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $th.removeClass("active");
  });
})

$(document).on("change", ".new-mm-pdp-v3:not(.new-mm-pdp-v4) .new-sub-sp-select", function(){
  if($(this).parents("section").find(".new-mm-pdp-buy-sub-btn").length > 0){
    $(this).parents("section").find(".new-mm-pdp-buy-sub-btn").attr("data-selling-plan", $(this).val());
  }
})
$(document).on("click", ".new-htut-tab--htu", function(){
  let id = $(this).attr("data-id");
  $(this).parent().find(".new-htut-tab--htu").removeClass("active");
  $(this).addClass("active");
  $(".new-uat").hide();
  $(`.new-uat[data-id="${id}"]`).show();
  $(this).parents(".new-htut").removeClass("tabs-section-bg-1").removeClass("tabs-section-bg-2").removeClass("tabs-section-bg-3");
  $(this).parents(".new-htut").addClass($(this).attr("data-class"));
});

$(document).on("click", ".new-htut-tab--wi", function(){
  let id = $(this).attr("data-id");
  $(this).parent().find(".new-htut-tab--wi").removeClass("active");
  $(this).addClass("active");
  $(".new-uat2").hide();
  $(`.new-uat2[data-id="${id}"]`).show();
  $(this).parents(".new-htut").removeClass("tabs-section-bg-1").removeClass("tabs-section-bg-2").removeClass("tabs-section-bg-3");
  $(this).parents(".new-htut").addClass($(this).attr("data-class"));
});

$(document).on("change", ".new-mm-pdp-v4 .v3-buy", function(){
  let val = $(this).val().toLowerCase().trim();
  if(val == "v3-sub"){
    $(this).parents(".new-mm-pdp-v4").find(`.custom-sub-opt[value="sub"] + label`).trigger("click");
  }
  else if(val == "v3-one"){
    $(this).parents(".new-mm-pdp-v4").find(`.custom-sub-opt[value="one"] + label`).trigger("click");
  }
})

$(document).on("submit", ".new-quiz-form", function(e){
  e.preventDefault();
  $(this).parents(".new-quiz-wrapper").find(".new-quiz-item").removeClass("active");
  $(this).parents(".new-quiz-item").next().addClass("active");
  if($(this).parents(".new-quiz-item").next().hasClass("new-quiz-item--result")){
    let total_score = 0;
    $(this).parents(".new-quiz-wrapper").find(".new-quiz-score-input:checked").each(function(){
      total_score += parseInt($(this).val());
    })
    $(this).parents(".new-quiz-wrapper").find(".new-quiz-result-score span").text(total_score);
    $(this).parents(".new-quiz-wrapper").find(".new-quiz-result-wrapper").each(function(){
      let scores = $(this).attr("data-total-score").split(",");
      let match = false;
      for (let i = 0; i < scores.length; i++){
        if(parseInt(scores[i]) == total_score && match == false){
          match = true;
          $(this).addClass("active");
        }
      }
    })
  }
})

$(document).on("click", ".new-quiz-back-btn", function(){
  $(this).parents(".new-quiz-wrapper").find(".new-quiz-item").removeClass("active");
  $(this).parents(".new-quiz-item").prev().addClass("active");
})

$(function ($) {
  $('.new-quiz-email-btn').on('click', function (e) {
    if($(this).parents(".new-quiz-item--email").find('.klaviyo-form input[type="email"]').length > 0){
      let $this = $(this);
      var email = $.trim($(this).parents(".new-quiz-item--email").find(".new-quiz-email-input").val());
      var $klaviyoInput = $(this).parents(".new-quiz-item--email").find('.klaviyo-form input[type="email"]');
      var input = $klaviyoInput.get(0);
      if (!email || !input) return;
      var nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      nativeSetter.call(input, email);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('blur', { bubbles: true }));
      console.log(email);
      setTimeout(function () {
        $this.parents(".new-quiz-item--email").find('.klaviyo-form button[type="submit"], .klaviyo-form input[type="submit"]').trigger('click');
      }, 100);
    }
  });
});

$(document).on("click", ".new-exit-intent-popup-overlay, .new-exit-intent-popup-close", function(){
  $(".new-exit-intent-popup-overlay, .new-exit-intent-popup").fadeOut(300);
  $("html, body").removeClass("overflow--hidden");
  if($(".new-dynamic-product-sticky-btn").length > 0){
    $(".new-dynamic-product-sticky-btn").removeClass("sticky-hide-important");
  }
})

function buildKlaviyoPayload(_email, _id, _form) {
  return {
    data: {
      type: 'subscription',
      attributes: {
        custom_source: _form,
        profile: {
          data: {
            type: 'profile',
            attributes: {
              email: _email
            }
          }
        }
      },
      relationships: {
        list: {
          data: {
            type: 'list',
            id: _id
          }
        }
      }
    }
  };
}

$(document).on("submit", ".new-exit-intent-popup-form", async function(e){
  e.preventDefault();
  let $this = $(this);
  let btn = $(this).find(".new-exit-intent-popup-btn");
  let inp = $(this).find(".new-exit-intent-popup-inp");
  let KLAVIYO_COMPANY_ID = 'TaWKDA';
  let KLAVIYO_LIST_ID = inp.attr("data-list-id");
  let payload = buildKlaviyoPayload(inp.val(), KLAVIYO_LIST_ID, 'Exit Intent Popup Form');

  if(btn.length > 0){
    btn.addClass("active");
    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2023-12-15'
          },
          body: JSON.stringify(payload)
        }
      );

      if (res.status === 202) {
        console.log('Quiz submitted to Klaviyo');

        const formData = {
          items: [
            {
              id: btn.attr("data-id"),
              quantity: 1
            }
          ]
        };

        try {
          const cartRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          });

          const cartData = await cartRes.json();

          if (cartData.status) {
            console.error('Cart add error:', cartData);
            btn.removeClass("active");
          } else {
            localStorage.setItem("exit-intent-popup", "added");
            location.href = '/checkout';
            return;
          }
        } catch (cartErr) {
          console.error('Cart add network error:', cartErr);
          btn.removeClass("active");
        }
      } else {
        const err = await res.json();
        console.error('Klaviyo quiz error:', err);
        btn.removeClass("active");
      }
    } catch (err) {
      console.error('Network error:', err);
      btn.removeClass("active");
    }
  }
})

$(document).on('click', '.btn-add-tocart', function(){
  $(this).addClass('active');
})

$(document).on("click", ".new-footer-heading", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  }
  else{
    $(this).parents(".new-footer-wrapper").find(".new-footer-heading").removeClass("active");
    $(this).parents(".new-footer-wrapper").find(".new-footer-menu-ul").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
  }
})

$(function(){
  let mainAtcBtn = $(".new--main--prod--class .new-main-product-submit");
  let footer = $(".new-footer");
  let stickyBtn = $(".new--main--prod--class .new-main-product-sticky-btn");

  if(mainAtcBtn.length > 0 && footer.length > 0 && stickyBtn.length > 0){
    let mt = mainAtcBtn.offset().top;
    let footerTop = footer.offset().top;

    $(document).scroll(function() {
      var y = $(this).scrollTop();
      var windowBottom = y + $(window).height();

      if (y > mt && windowBottom < footerTop) {
        stickyBtn.addClass('active');
      } else {
        stickyBtn.removeClass('active');
      }
    });
  }
})

$(document).on("click", ".new-main-product-sticky-btn", function(e){
  let href = $(this).attr("href");
  let id = $(href).find(".new-main-product-info-variants--block");
  if(id.length > 0){
    e.preventDefault();
    $('html, body').animate({
      scrollTop: id.offset().top - 70
    }, 500);
  }
})

$(function () {
  let stickyBtn = $(".new-dynamic-product-sticky-btn");
  if (stickyBtn.length > 0) {
    let section = stickyBtn.closest("section");
    function isSectionInView() {
      let sectionTop = section.offset().top;
      let sectionBottom = sectionTop + section.outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + $(window).height();
      return sectionBottom > viewportTop && sectionTop < viewportBottom;
    }
    function toggleSticky() {
      if (isSectionInView()) {
        stickyBtn.removeClass('active');
      } else {
        stickyBtn.addClass('active');
      }
    }
    toggleSticky();
    $(window).on('scroll', function () {
      toggleSticky();
    });
  }
});


class OptCountdownTimer extends HTMLElement {

  constructor() {
    super();
    this._interval = null;
  }

  connectedCallback() {
    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');
    const dateAttr = this.getAttribute('data-end-date');
    this.targetUTC = this.parseESTDateToUTC(dateAttr);
    this.tick();
    this._interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }
  }

  parseESTDateToUTC(str) {
    if (!str) return null;
    const months = {
      jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
      jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
    };
    const match = str.trim().match(
      /^([a-zA-Z]{3})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i
    );
    if (!match) {
      console.error('countdown-timer: invalid data-end-date format ->', str);
      return null;
    }
    let [, mon, day, year, hour, minute, ampm] = match;
    mon = mon.toLowerCase();
    day = parseInt(day, 10);
    year = parseInt(year, 10);
    hour = parseInt(hour, 10);
    minute = parseInt(minute, 10);
    ampm = ampm.toUpperCase();
    if (ampm === 'PM' && hour !== 12) hour += 12;
    if (ampm === 'AM' && hour === 12) hour = 0;
    const monthIndex = months[mon];
    if (monthIndex === undefined) {
      console.error('countdown-timer: invalid month ->', mon);
      return null;
    }
    const EST_OFFSET_HOURS = 5;
    return Date.UTC(year, monthIndex, day, hour + EST_OFFSET_HOURS, minute, 0);
  }

  tick() {
    if (!this.targetUTC) {
      this.render(0, 0, 0, 0);
      return;
    }
    const diff = this.targetUTC - Date.now();
    if (diff <= 0) {
      this.render(0, 0, 0, 0);
      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }
      this.dispatchEvent(new CustomEvent('countdown:expired', { bubbles: true }));
      return;
    }
    let remaining = diff;
    const days = Math.floor(remaining / 86400000);
    remaining -= days * 86400000;
    const hours = Math.floor(remaining / 3600000);
    remaining -= hours * 3600000;
    const minutes = Math.floor(remaining / 60000);
    remaining -= minutes * 60000;
    const seconds = Math.floor(remaining / 1000);
    this.render(days, hours, minutes, seconds);
  }

  pad(n) {
    return String(n).padStart(2, '0');
  }

  render(days, hours, minutes, seconds) {
    if (this.daysEl) this.daysEl.textContent = this.pad(days);
    if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
    if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
    if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
  }
}

customElements.define('opt-countdown-timer', OptCountdownTimer);


$(document).on("submit", ".new-optin-form", async function(e){
  e.preventDefault();
  let $this = $(this);
  let btn = $(this).find(".new-optin-form-btn");
  let inp = $(this).find(".new-optin-form-input");
  let success = $(this).parents(".new-optin-form-section").find(".new-optin-success");
  let KLAVIYO_COMPANY_ID = 'TaWKDA';
  let KLAVIYO_LIST_ID = inp.attr("data-list-id");
  let payload = buildKlaviyoPayload(inp.val(), KLAVIYO_LIST_ID, 'Opt In Form');
  btn.addClass("active");
  try {
    const res = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2023-12-15'
        },
        body: JSON.stringify(payload)
      }
    );
    if (res.status === 202) {
      console.log('Quiz submitted to Klaviyo');
      $this.removeClass('active');
      success.addClass('active');
      btn.removeClass("active");
    }
    else {
      const err = await res.json();
      console.error('Klaviyo quiz error:', err);
      btn.removeClass("active");
    }
  }
  catch (err) {
    console.error('Network error:', err);
    btn.removeClass("active");
  }
})


$(document).on("click", ".july-pdp-accordion-title", function(){
  if($(this).hasClass("active")){
    $(this).toggleClass("active");
    $(this).next().slideToggle(300);
  }
  else{
    $(this).parents(".july-pdp-accordion-wrapper").find(".july-pdp-accordion-title").removeClass("active");
    $(this).parents(".july-pdp-accordion-wrapper").find(".july-pdp-accordion-text").slideUp(300);
    $(this).addClass("active");
    $(this).next().slideDown(300);
  }
})

$(document).on("click", ".july-pdp-accordion-popup-btn", function(){
  let id = $(this).attr("data-id");
  if($(`.july-pdp-accordion-popup-container[data-id="${id}"]`).length > 0){
    $("html, body").addClass("overflow--hidden");
    $(`.july-pdp-accordion-popup-container[data-id="${id}"]`).fadeIn(300);
  }
})

$(document).on("click", ".july-pdp-accordion-popup-close", function(){
  $(this).parents(".july-pdp-accordion-popup-container").fadeOut(300);
  $("html, body").removeClass("overflow--hidden");
})

$(document).on("change", ".july-pdp-dropdown", function(){
  let enableAtc = true;
  $(this).parents(".july-pdp-dropdown-wrapper").find(".july-pdp-dropdown").each(function(){
    if($(this).val() == 'none' || $(this).val() == null){
      enableAtc = false;
    }
  })
  if(enableAtc){
    $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").removeClass("inactive");
    $(this).parents(".july-pdp-dropdown-wrapper").removeClass("none-selected");
    $(this).parents(".july-pdp-dropdown-wrapper").removeClass("please-select");
  }
  else{
    $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").addClass("inactive");
  }
})


function updateFlavorDropdown(slot, dataId){
  const $dropdown = $(".july-pdp-dropdown").eq(slot - 1);
  $dropdown.val(dataId).trigger("change");
}


function updateWrapperState(){
  const $wrapper = $(".july-pdp-dropdown-wrapper");
  const $selected = $(".july-pdp-variants-flavor.selected");

  const isCombo = $selected.length === 1 &&
    $selected.find(".july-pdp-variants-badge-bottom").attr("data-selected-title") === "FLAVOR 1 + 2";

  if ($selected.length === 2 || isCombo) {
    $wrapper.removeClass("none-selected");
    $(".july-pdp-variants-container").removeClass("pdp-select-error");
  } else {
    $wrapper.addClass("none-selected");
  }

  if($(".july-pdp-dropdown-wrapper").length > 0){
    if($(`.july-pdp-dropdown-wrapper`).hasClass("none-selected")){
      $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").addClass("inactive");
    }
    else{
      $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").removeClass("inactive");
    }
  }
  else{
    $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").removeClass("inactive");
  }
}

$(document).on("click", ".july-pdp-variants-flavor", function(){
  const $this = $(this);
  const $selected = $(".july-pdp-variants-flavor.selected");
  const dataId = $this.attr("data-id");

  if ($this.hasClass("selected")) {
    const currentTitle = $this.find(".july-pdp-variants-badge-bottom").attr("data-selected-title");

    if (currentTitle === "FLAVOR 1 + 2") {
      $this.find(".july-pdp-variants-badge-bottom").attr("data-selected-title", "FLAVOR 1");
    }
    else if ($selected.length === 1) {
      $this.find(".july-pdp-variants-badge-bottom").attr("data-selected-title", "FLAVOR 1 + 2");
      updateFlavorDropdown(1, dataId);
      updateFlavorDropdown(2, dataId);
    }
    else {
      $this.removeClass("selected");
      $this.find(".july-pdp-variants-badge-bottom").removeAttr("data-selected-title");

      const $remaining = $(".july-pdp-variants-flavor.selected");
      if ($remaining.length === 1) {
        $remaining.find(".july-pdp-variants-badge-bottom").attr("data-selected-title", "FLAVOR 1");
        updateFlavorDropdown(1, $remaining.attr("data-id"));
      }
    }
  } else {
    if ($selected.length === 1) {
      const otherTitle = $selected.find(".july-pdp-variants-badge-bottom").attr("data-selected-title");

      if (otherTitle === "FLAVOR 1 + 2") {
        return;
      }

      $this.addClass("selected");
      $this.find(".july-pdp-variants-badge-bottom").attr("data-selected-title", "FLAVOR 2");
      updateFlavorDropdown(2, dataId);
    }
    else if ($selected.length === 2) {
      const $flavor2 = $selected.filter(function(){
        return $(this).find(".july-pdp-variants-badge-bottom").attr("data-selected-title") === "FLAVOR 2";
      });

      $flavor2.removeClass("selected");
      $flavor2.find(".july-pdp-variants-badge-bottom").removeAttr("data-selected-title");

      $this.addClass("selected");
      $this.find(".july-pdp-variants-badge-bottom").attr("data-selected-title", "FLAVOR 2");
      updateFlavorDropdown(2, dataId);
    }
    else {
      $this.addClass("selected");
      $this.find(".july-pdp-variants-badge-bottom").attr("data-selected-title", "FLAVOR 1");
      updateFlavorDropdown(1, dataId);
    }
  }

  updateWrapperState();
});


function updateJulyPDPVariant(){

  let $this = null;
  if($(".july-pdp-variants-inp:checked").length > 0){
    $this = $(".july-pdp-variants-inp:checked");
  }
  else{
    $(".july-pdp-variants-inp:not(.july-pdp-variants-inp-to-hide)").eq(0).trigger("click");
    return;
  }

  if($(`.july-pdp-img[data-img="${$this.attr("data-img")}"]`).length > 0){
    let ind = parseInt($(`.july-pdp-img[data-img="${$this.attr("data-img")}"]`).attr("data-index"));
    $(".july-pdp-swiper")[0].swiper.slideTo(ind);
  }

  if($this.hasClass("july-pdp-variants-inp-to-hide")){
    $(".july-pdp-variants-inp").attr("type", "checkbox");
    $(".july-pdp-variants-flavor").addClass("active");
    $(".july-pdp-variants-inp:not(.july-pdp-variants-inp-to-hide)").addClass("pdp-flavors-inp-hide");
    if($(".july-pdp-dropdown-wrapper").length > 0){
      $(".july-pdp-dropdown-wrapper").addClass("active");
      $(".july-pdp-variants-flavor").removeClass("selected");
      $(".july-pdp-dropdown").each(function(){
        $(`.july-pdp-variants-flavor[data-id="${$(this).val()}"]`).trigger("click");
      })
    }
    $('.july-pdp-subscription-input[data-plan="1"]').trigger("click");
    // if($this.attr("data-price-1") != undefined){
    //   $(".july-pdp-subscription").eq(0).find(".july-pdp-subscription-price-container").html($this.attr("data-price-1"));
    // }
  }
  else{
    $(".july-pdp-variants-container").removeClass("pdp-select-error");
    $(".july-pdp-variants-inp").attr("type", "radio");
    $(".july-pdp-variants-flavor").removeClass("active");
    $(".july-pdp-variants-inp:not(.july-pdp-variants-inp-to-hide)").removeClass("pdp-flavors-inp-hide");
    if($(".july-pdp-dropdown-wrapper").length > 0){
      $(".july-pdp-dropdown-wrapper").removeClass("active");
    }
    // if($this.attr("data-price-1") != undefined){
    //   $(".july-pdp-subscription").eq(0).find(".july-pdp-subscription-price-container").html($this.attr("data-price-1"));
    // }
    if($this.attr("data-price-2") != undefined){
      $(".july-pdp-subscription").eq(1).find(".july-pdp-subscription-price-container").html($this.attr("data-price-2"));
    }
    // $('.july-pdp-subscription-input[data-plan="2"]').trigger("click");
  }

  if($(".july-pdp-variants-inp-to-hide").length > 0){
    if($(".july-pdp-variants-inp-to-hide").attr("data-price-1") != undefined){
      $(".july-pdp-subscription").eq(0).find(".july-pdp-subscription-price-container").html($(".july-pdp-variants-inp-to-hide").attr("data-price-1"));
    }
  }

  //Sticky Dropdown
  if($(".july-pdp-sticky-dropdown-item").length > 0){
    if($this.attr("data-sticky-1") != undefined){
      $(".july-pdp-summary").html($(".july-pdp-variants-inp-to-hide").attr("data-sticky-1"));
      $(".july-pdp-sticky-dropdown-item").eq(0).html($(".july-pdp-variants-inp-to-hide").attr("data-sticky-1"));
    }
    if($this.attr("data-sticky-2") != undefined){
      $(".july-pdp-sticky-dropdown-item").eq(1).html($(".july-pdp-variants-inp-to-hide").next().next().attr("data-sticky-2"));
    }
  }
  // if($(".july-pdp-sticky-dropdown-item").length > 0){
  //   if($(".july-pdp-subscription-input:checked").attr("data-plan") == "1"){
  //     if($this.attr("data-sticky-1") != undefined){
  //       $(".july-pdp-summary").html($this.attr("data-sticky-1"));
  //       $(".july-pdp-sticky-dropdown-item").eq(0).html($this.attr("data-sticky-1"));
  //     }
  //     if($this.attr("data-sticky-2") != undefined){
  //       $(".july-pdp-sticky-dropdown-item").eq(1).html($this.next().next().attr("data-sticky-2"));
  //     }
  //   }
  //   else if($(".july-pdp-subscription-input:checked").attr("data-plan") == "2"){
  //     if($this.attr("data-sticky-1") != undefined){
  //       $(".july-pdp-sticky-dropdown-item").eq(0).html($this.attr("data-sticky-1"));
  //     }
  //     if($this.attr("data-sticky-2") != undefined){
  //       $(".july-pdp-summary").html($this.attr("data-sticky-2"));
  //       $(".july-pdp-sticky-dropdown-item").eq(1).html($this.attr("data-sticky-2"));
  //     }
  //   }
  // }

  $(".july-pdp-atc-one").text($this.attr("data-price"));

  if($(".july-pdp-subscription-input:checked").attr("data-plan") == '1' && !$this.hasClass("july-pdp-variants-inp-to-hide")){
    $(".july-pdp-atc-one").text($this.attr("data-price-new"));
  }

  //Subscription Box Update
  if($this.attr("data-has-selling-plan") == "false"){
    $(".july-pdp-subscription-container").addClass("july-pdp-subscription-hide");
    if($(".july-pdp-sticky-wrapper").length > 0){
      $(".july-pdp-sticky-wrapper").addClass("july-pdp-subscription-hide");
    }
  }
  else{
    $(".july-pdp-subscription-container").removeClass("july-pdp-subscription-hide");
    if($(".july-pdp-sticky-wrapper").length > 0){
      $(".july-pdp-sticky-wrapper").removeClass("july-pdp-subscription-hide");
    }
  }

  //Add To Cart Validations
  $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").removeClass("inactive");
  if($this.attr("data-sold") == "sold"){
    $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").addClass("sold");
  }
  else{
    $(".july-pdp-atc, .july-pdp-atc-one, .july-pdp-sticky-btn").removeClass("sold");
  }
  $(".july-pdp-atc, .july-pdp-atc-one").attr("data-id", $this.val());

}


$(document).on("change", ".july-pdp-variants-inp", function(){
  updateJulyPDPVariant();
})


$(document).on("change", ".july-pdp-subscription-input", function(){
  $(".july-pdp-atc, .july-pdp-atc-one").attr("data-selling-plan", $(this).val());
  if($(this).attr("data-plan") == '1'){
    // $(".july-pdp-variants-inp.july-pdp-variants-inp-to-hide").eq(0).prop("checked", true);
  }
  else{
    $(".july-pdp-variants-inp").prop("checked", false);
    $(".july-pdp-variants-inp:not(.july-pdp-variants-inp-to-hide)").eq(0).prop("checked", true);
  }
  updateJulyPDPVariant();
  if($(".july-pdp-sticky-dropdown-item").length > 0){
    $(".july-pdp-sticky-dropdown-item").removeClass("active");
    $(`.july-pdp-sticky-dropdown-item[data-plan="${$(this).attr("data-plan")}"]`).addClass("active");
    $(".july-pdp-summary").html($(`.july-pdp-sticky-dropdown-item[data-plan="${$(this).attr("data-plan")}"]`).html());
    $(".july-pdp-sticky-btn").html($(".july-pdp-sticky-dropdown-item.active").find("p").attr("data-pm"));
  }
});


$(document).on("click", ".july-pdp-sticky-dropdown-item", function(e){
  $(".july-pdp-sticky-dropdown-item").removeClass("active");
  $(this).addClass("active");
  let html = $(this).html();
  $(this).parents(".july-pdp-details").find(".july-pdp-summary").html(html);
  $(this).parents(".july-pdp-details").removeAttr("open");
  $(`.july-pdp-subscription-input[data-plan="${$(this).attr("data-plan")}"]`).trigger("click");
  $(".july-pdp-sticky-btn").html($(this).find("p").attr("data-pm"));
  if($(".july-pdp-block-form").length > 0){
    let top = $(".july-pdp-block-form").offset().top;
    $("html, body").animate({ scrollTop: top }, 500);
  }
})

$(document).on("click", ".july-pdp-atc", function(){
  if($(this).hasClass("inactive")){
    if($(".july-pdp-block-form").length > 0){
      let top = $(".july-pdp-block-form").offset().top - 100;
      $("html, body").animate({ scrollTop: top }, 500);
    }
    $(".july-pdp-variants-container").addClass("pdp-select-error");
    return;
  }
  let bundleCode = Date.now();
  let $this = $(this);
  $this.addClass("active");
  if($(".july-banner-link").length > 0){
    $(".july-banner-link").addClass("active");
  }
  if($(".july-pdp-sticky-btn").length > 0){
    $(".july-pdp-sticky-btn").addClass("active");
  }
  let arr = [];
  let qty = 1;
  if($(".july-pdp-subscription-input:checked").attr("data-plan") == '1'){
    qty = 2;
  }
  if($(".july-pdp-subscription-input:checked + .july-pdp-subscription-label").find(".july-pdp-subscription-upsells").length > 0){
    $(".july-pdp-subscription-input:checked + .july-pdp-subscription-label").find(".july-pdp-subscription-upsells").each(function(){
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': 1,
        'properties': {
          'Bundle ID': bundleCode
        }
      })
    })
  }
  if($(".july-pdp-dropdown-wrapper.active").length > 0){
    if($(".july-pdp-variants-inp:checked").hasClass("july-pdp-variants-inp-to-hide")){
      $(".july-pdp-dropdown-wrapper.active").find(".july-pdp-dropdown").each(function(){
        arr.push({
          'id': $(this).val(),
          'quantity': 1,
          'selling_plan': $this.attr("data-selling-plan"),
          'properties': {
            'Bundle ID': bundleCode,
            'Bundle': $(".july-pdp-variants-inp:checked").attr("data-title")
          }
        })
      })
    }
    else{
      $(".july-pdp-dropdown-wrapper.active").find(".july-pdp-dropdown").each(function(){
        arr.push({
          'id': $(this).val(),
          'quantity': 1,
          'selling_plan': $this.attr("data-selling-plan"),
          'properties': {
            'Bundle ID': bundleCode
          }
        })
      })
    }
  }
  else{
    if($(".july-pdp-variants-inp:checked").hasClass("july-pdp-variants-inp-to-hide")){
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': 1,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {
          'Bundle ID': bundleCode,
          'Bundle': $(".july-pdp-variants-inp:checked").attr("data-title")
        }
      })
    }
    else{
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': qty,
        'selling_plan': $this.attr("data-selling-plan"),
        'properties': {
          'Bundle ID': bundleCode,
          'Bundle': $(".july-pdp-variants-inp-to-hide.july-pdp-variants-inp").attr("data-title")
        }
      })
    }
  }
  let formData = {
    'items': arr
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      setTimeout(function(){
        $(".cart-icon-wrap .open-drawer").trigger("click");
      }, 500)
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
    if($(".july-banner-link").length > 0){
      $(".july-banner-link").removeClass("active");
    }
    if($(".july-pdp-sticky-btn").length > 0){
      $(".july-pdp-sticky-btn").removeClass("active");
    }
  });
})

$(document).on("click", ".july-pdp-atc-one", function(){
  let bundleCode = Date.now();
  let $this = $(this);
  $this.addClass("active");
  let arr = [];
  let qty = 1;
  if($(".july-pdp-subscription-input:checked").attr("data-plan") == '1'){
    qty = 2;
  }
  if($(".july-pdp-dropdown-wrapper.active").length > 0){
    if($(".july-pdp-variants-inp:checked").hasClass("july-pdp-variants-inp-to-hide")){
      $(".july-pdp-dropdown-wrapper.active").find(".july-pdp-dropdown").each(function(){
        arr.push({
          'id': $(this).val(),
          'quantity': 1,
          'properties': {
            'Bundle ID': bundleCode,
            'Bundle': $(".july-pdp-variants-inp:checked").attr("data-title")
          }
        })
      })
    }
    else{
      $(".july-pdp-dropdown-wrapper.active").find(".july-pdp-dropdown").each(function(){
        arr.push({
          'id': $(this).val(),
          'quantity': 1,
          'properties': {
            'Bundle ID': bundleCode
          }
        })
      })
    }
  }
  else{
    if($(".july-pdp-variants-inp:checked").hasClass("july-pdp-variants-inp-to-hide")){
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': 1,
        'properties': {
          'Bundle': $(".july-pdp-variants-inp:checked").attr("data-title")
        }
      })
    }
    else{
      arr.push({
        'id': $(this).attr("data-id"),
        'quantity': qty
      })
    }
  }
  let formData = {
    'items': arr
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(function(res){
    if(res.status){
      console.log("error");
    }
    else{
      $(".cart-icon-wrap .open-drawer").trigger("click");
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  })
  .finally(function(){
    $this.removeClass("active");
  });
})

$(document).on("click", ".july-pdp-sticky-btn", function(){
  $(".july-pdp-atc").trigger("click");
})


if($(".july-banner-section").length > 0){
  $(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 300) {
      $(".july-banner-section").addClass('active');
    } else {
      $(".july-banner-section").removeClass('active');
    }
  });
}

$(document).on("click", ".july-banner-link", function(e){
  if($(".july-pdp-subscription-input:checked").length > 0){
    e.preventDefault();
    if($(".july-pdp-subscription-input:checked").attr("data-plan") == "1"){
      $(".july-pdp-atc:not(.sold)").trigger("click");
    }
    else{
      $('.july-pdp-subscription-input[data-plan="1"]').trigger("click");
      if($(".july-pdp-block-form").length > 0){
        let top = $(".july-pdp-block-form").offset().top - 100;
        $("html, body").animate({ scrollTop: top }, 500);
      }
    }
  }
})

$(document).on("click", ".july-pdp-summary", function(e){
  e.stopPropagation();
})

$(document).on("click", function(){
  $(".july-pdp-details").removeAttr("open");
})

$(function(){
  if($(".july-pdp-variants-inp").length > 0 && $(".july-pdp-subscription").length > 0){
    if($(".july-pdp-variants-inp:checked").hasClass("july-pdp-variants-inp-to-hide")){
      if($(".july-pdp-variants-inp").eq(1).attr("data-price-2") != undefined){
        $(".july-pdp-subscription").eq(1).find(".july-pdp-subscription-price-container").html($(".july-pdp-variants-inp").eq(1).attr("data-price-2"));
      }
    }
  }
  if($(".new-main-product-option-value-input").length > 0 && $(".new-main-product-info-wrapper").length > 0){
    if($(".new-main-product-info-wrapper").attr("data-default") != undefined && $(".new-main-product-info-wrapper").attr("data-default") != "none"){
      $(`.new-main-product-option-value-input[value="${$(".new-main-product-info-wrapper").attr("data-default").trim()}"]`).trigger("click");
    }
  }
})

class OfferCountdownTimer extends HTMLElement {
  constructor() {
    super();
    this._interval = null;
  }

  connectedCallback() {
    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');
    this.cookieName = this.getAttribute('data-cookie-name') || 'countdown_timer_end';
    const hoursAttr = parseFloat(this.getAttribute('data-hours'));
    this.hours = isNaN(hoursAttr) || hoursAttr <= 0 ? 0 : hoursAttr;
    this.targetMs = this.getOrCreateTarget();
    this.tick();
    this._interval = setInterval(() => this.tick(), 1000);
  }
  disconnectedCallback() {
    if (this._interval) {
      clearInterval(this._interval);
      this._interval = null;
    }
  }
  getOrCreateTarget() {
    const existing = this.getCookie(this.cookieName);
    const existingMs = existing ? parseInt(existing, 10) : NaN;
    if (!isNaN(existingMs)) {
      return existingMs;
    }
    const target = Date.now() + this.hours * 3600000;
    this.setCookie(this.cookieName, String(target), this.hours);
    return target;
  }
  getCookie(name) {
    const escaped = name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }
  setCookie(name, value, hours) {
    const expiryDate = new Date(Date.now() + hours * 3600000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expiryDate.toUTCString()}; path=/`;
  }
  tick() {
    const diff = this.targetMs - Date.now();
    if (diff <= 0) {
      this.render(0, 0, 0, 0);
      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }
      return;
    }
    let remaining = diff;
    const days = Math.floor(remaining / 86400000);
    remaining -= days * 86400000;
    const hours = Math.floor(remaining / 3600000);
    remaining -= hours * 3600000;
    const minutes = Math.floor(remaining / 60000);
    remaining -= minutes * 60000;
    const seconds = Math.floor(remaining / 1000);
    this.render(days, hours, minutes, seconds);
  }
  pad(n) {
    return String(n).padStart(2, '0');
  }
  render(days, hours, minutes, seconds) {
    if (this.daysEl) this.daysEl.textContent = this.pad(days);
    if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
    if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
    if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
  }
}
customElements.define('offer-countdown-timer', OfferCountdownTimer);